import React from 'react';
import T from 'prop-types';
import { Button, Skeleton, Form, Divider } from 'antd';
import { CreditCardOutlined } from '@ant-design/icons';

import { CUSTOMER_PORTAL_URL } from '../../../../constants/app';
import { email } from '../../../../attrs/content';

import ErrorAlert from '../../../errorAlert';
import FormItem from '../../../formItem';

import { Note, StyledCard, Title, FormActions } from './style';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 19 },
  },
};

const BillingDetailsCard = ({
  cardNumber,
  cardExpiration,
  isUserStandard,
  isLoading,
  error,
  errorMessage,
  address,
}) => {
  if (isUserStandard) {
    return null;
  }

  const content = (
    <>
      <Title>Credit Card</Title>
      <Form name="billingDetailsCard" {...formItemLayout} size="small">
        <FormItem label="Card Number">{cardNumber}</FormItem>
        <FormItem label="Expiration">{cardExpiration}</FormItem>
      </Form>
      <FormActions>
        <Button href={CUSTOMER_PORTAL_URL} icon={<CreditCardOutlined />} type="primary">
          Update Card Details
        </Button>
      </FormActions>

      <Divider />

      <Title>Billing Address</Title>
      <Form name="billingDetailsAddress" {...formItemLayout} size="small">
        <FormItem label="Address line 1">{address.line1}</FormItem>
        <FormItem label="Address line 2">{address.line2}</FormItem>
        <FormItem label="Postal Code">{address.postalCode}</FormItem>
        <FormItem label="City">{address.city}</FormItem>
        <FormItem label="State">{address.state}</FormItem>
        <FormItem label="Country">{address.country}</FormItem>
      </Form>
    </>
  );

  return (
    <StyledCard bordered={false} title="Billing Details">
      <ErrorAlert message={errorMessage} visible={error} />
      {isLoading ? <Skeleton active paragraph={{ rows: 3 }} title={false} /> : content}
      <Note>
        Note: Currently it is not possible to change your billing address automatically. Please contact us at{' '}
        <a href={`mailto:${email}`}>contact@glassnode.com</a> and our team will be happy to help.
      </Note>
    </StyledCard>
  );
};

BillingDetailsCard.propTypes = {
  address: T.object.isRequired,
  cardExpiration: T.string.isRequired,
  cardNumber: T.string.isRequired,
  error: T.bool.isRequired,
  errorMessage: T.string.isRequired,
  isLoading: T.bool.isRequired,
  isUserStandard: T.bool.isRequired,
};

export default BillingDetailsCard;
